import { TypeValueUtils } from '@/core/utils/index'

export default class HasValueParamUtils {
	constructor(configParams) {
		this._configParams = this._configParam(configParams)
	}

	hasValue(param) {
		return (
			this.hasValueStringParam(param) ||
			this.hasValueNumberParam(param) ||
			this.hasValueArrayParam(param) ||
			this.hasValueBooleanParam(param)
		)
	}

	hasValueKeysObject(param) {
		let hasValueObject = false
		for (const value of Object.values(param)) {
			if (this.hasValue(value)) {
				hasValueObject = true
				break
			}
		}
		return hasValueObject
	}

	_configParam(configParams = {}) {
		return Object.assign(
			{
				minLengthString: 1,
				minLengthArray: 1,
				minNumber: 0,
			},
			configParams,
		)
	}

	hasValueStringParam(param) {
		return TypeValueUtils.isString(param) && param.length >= this._configParams.minLengthString
	}

	hasValueNumberParam(param) {
		return TypeValueUtils.isNumber(param) && param >= this._configParams.minNumber
	}

	hasValueArrayParam(param) {
		return TypeValueUtils.isArray(param) && param.length >= this._configParams.minLengthArray
	}

	hasValueBooleanParam(param) {
		return TypeValueUtils.isBoolean(param)
	}
}
